var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.id
    ? _c("span", { class: _vm.className }, [
        _vm._v("\n  " + _vm._s(_vm.$modeoL10n[_vm.id]) + "\n")
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c574977", { render: render, staticRenderFns: staticRenderFns })
  }
}